export default "__VITE_PUBLIC_ASSET__35767979__"